import React from 'react';
import {useTranslation} from 'react-i18next';
import Button from '@material-ui/core/Button';
import StatusPill from './StatusPill';
import settingsStyles from '../settingsStyles';
import UnpublishWebButton from '../../CreateWeb/components/UnpublishWeb/UnpublishWebButton';
import PublishWeb from '../../CreateWeb/components/PublishWeb/PublishWeb';
import {BASE_LIVE_WEB} from '../../../../../constants/api.constants';

// Yayin durumu: canli / DNS bekliyor / yayinda degil.
// Publish ve unpublish, dashboard ile ayni publishWebSubmit action'ini kullanir.
export default function PublishCard({domain, webReducer, isPublish, onPublish, onSuccessClose}) {
    const {t} = useTranslation();
    const classes = settingsStyles();

    const published = domain && domain.is_published === 1;
    const dnsChecked = domain && domain.is_dns_checked === 1;
    const waitingDns = published && !dnsChecked;

    const liveUrl = domain && domain.token ? BASE_LIVE_WEB + domain.token : null;

    const state = waitingDns
        ? {
            beacon: classes.beaconWait,
            icon: 'fas fa-clock',
            pill: <StatusPill tone="warn" label={t('enw-web-settings-publish_pending', 'DNS bekleniyor')} />,
            title: t('enw-web-settings-publish_wait_title', 'Site yayına alınıyor'),
            desc: t('btn-wait-publish'),
        }
        : published
            ? {
                beacon: classes.beaconLive,
                icon: 'fas fa-globe',
                pill: <StatusPill tone="ok" label={t('enw-web-settings-publish_live', 'Canlı')} />,
                title: t('enw-web-settings-publish_live_title', 'Site yayında'),
                desc: t('enw-web-settings-publish_live_desc', 'Ziyaretçiler siteye erişebiliyor ve rezervasyon yapabiliyor.'),
            }
            : {
                beacon: classes.beaconOff,
                icon: 'fas fa-power-off',
                pill: <StatusPill tone="off" label={t('enw-web-settings-publish_offline', 'Yayında değil')} />,
                title: t('enw-web-settings-publish_offline_title', 'Site yayında değil'),
                desc: t('enw-web-settings-publish_offline_desc', 'Siteniz hazır ancak yayına alınmadı. Yayınladığınızda DNS doğrulaması başlar.'),
            };

    return (
        <section className={classes.card} id="yayin">
            <div className={classes.publish}>
                <div className={classes.publishState}>
                    <span className={`${classes.beacon} ${state.beacon}`}>
                        <i className={state.icon} />
                    </span>
                    <div>
                        <h3 className={classes.publishTitle}>
                            {state.title}
                            {state.pill}
                        </h3>
                        <p className={classes.publishDesc}>{state.desc}</p>
                    </div>
                </div>

                <div className={classes.publishActions}>
                    {liveUrl && (
                        <Button
                            className={classes.btn}
                            href={liveUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            startIcon={<i className="fas fa-eye" />}
                        >
                            {t('btn-site_preview')}
                        </Button>
                    )}

                    {published ? (
                        <UnpublishWebButton
                            domain={domain}
                            className={`${classes.btn} ${classes.btnDanger}`}
                            fullwidth={false}
                            startIcon={<i className="fas fa-power-off" />}
                            onConfirm={onPublish(domain && domain.id, 0)}
                        />
                    ) : (
                        <Button
                            className={`${classes.btn} ${classes.btnPrimary}`}
                            startIcon={<i className="fas fa-rocket" />}
                            onClick={onPublish(domain && domain.id, 1)}
                        >
                            {t('btn-publish')}
                        </Button>
                    )}

                    <PublishWeb
                        publishWeb={webReducer}
                        isPublish={isPublish}
                        onSuccessClose={onSuccessClose}
                    />
                </div>
            </div>
        </section>
    );
}
